import React, { useMemo } from 'react'
import { usePropertyDetails } from '../../../hooks/use-property-details'

export interface PropertyDetailsProps {}

export const PropertyDetails = () => {
  const { erfNo, schemeName, schemeNo, sectionNo, address, owners } =
    usePropertyDetails()
  const hasOwners = useMemo(() => owners.length !== 0, [owners])
  return (
    <div>
      <table style={{ width: '600px', marginTop: '20px' }}>
        <tr className="rowBorder">
          <td
            className="labelMargin colBorderSpliter"
            style={{ width: '150px' }}
          >
            {' '}
            <span className="detailLabel">Owner(s)</span>
          </td>
          <td className="labelMargin">
            {!hasOwners && (
              <span style={{ color: 'red' }}>
                We could not find owners for this property!
              </span>
            )}
            {hasOwners &&
              owners.map((owner, index) => (
                <div key={index}>
                  <span>{owner.trim()}</span>
                  {index < owners.length - 1 && <br />}
                </div>
              ))}
          </td>
        </tr>

        {erfNo && !schemeName && (
          <tr className="rowBorder">
            <td className="labelMargin colBorderSpliter">
              <span className="detailLabel">ERF No</span>
            </td>
            <td className="labelMargin">
              <span className="">{erfNo}</span>
            </td>
          </tr>
        )}

        {schemeName && (
          <tr className="rowBorder">
            <td className="labelMargin colBorderSpliter">
              <span className="detailLabel">Scheme Name:</span>
            </td>
            <td className="labelMargin">
              <span className="">{schemeName}</span>
            </td>
          </tr>
        )}

        {sectionNo ? (
          <tr className="rowBorder">
            <td className="labelMargin colBorderSpliter">
              <span className="detailLabel">Section No:</span>
            </td>
            <td className="labelMargin">
              <span className="">{sectionNo}</span>
            </td>
          </tr>
        ) : null}

        <tr className="rowBorder">
          <td className="labelMargin colBorderSpliter">
            <span className="detailLabel">Address:</span>
          </td>

          <td className="labelMargin">
            <span className="">{address}</span>
          </td>
        </tr>
      </table>
    </div>
  )
}

export default PropertyDetails
